// extracted by mini-css-extract-plugin
module.exports = {"title":"DialogWindow_title__2e_m2","bold":"DialogWindow_bold__T8yqU"};